import React, { createContext, FC, memo, ReactNode, useContext } from 'react';
import { PaletteMode } from '@mui/material';

type ThemeModeProps = { toggleThemeMode: (mode: PaletteMode) => void };

const ThemeModeContext = createContext<ThemeModeProps>({} as ThemeModeProps);

export const useThemeMode = (): ThemeModeProps => useContext<ThemeModeProps>(ThemeModeContext);

export const ThemeModeProvider: FC<ThemeModeProps & { children: ReactNode }> = memo(({ toggleThemeMode, children }) => {
  return <ThemeModeContext.Provider value={{ toggleThemeMode }}>{children}</ThemeModeContext.Provider>;
});
